export const appGroups = "xTBF6d";
export default {appGroups};